<div class="card">

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/valore-punti-erogati-indicator/valore-punti-erogati-indicator.component.html